import { connect } from 'react-redux'
import { IStateProps, IDispatchProps } from './YumManualEntryForm'
import {
  addCustomEntry,
  getCustomProgressForPoints,
  setManualEntryPointsLogicId,
  setManualEntryProgressType,
} from '../../views/Progress/store/ProgressActions'
import YumManualEntryForm from './YumManualEntryForm'
import { IGlobalState } from '../../Root/store/appReducer'
import { GoalWithProgress, UserId } from '../../services/api.types'
import {
  getAllDailyProgressSelector,
  getCustomProgressRawSelector,
  getIsManualEntryInProgress,
  getManualEntryPointsLogicIdSelector,
  getManualEntryProgressTypeSelector,
} from '../../views/Progress/store/progressSelectors'
import { PointsLogicId } from '../../views/ChallengeAdmin/components/ChallengePoints/ChallengePoints'
import { getUserCompanies } from '../../common/auth/authSelectors'

export interface IOwnProps {
  goal: GoalWithProgress
  isMeView: boolean
  isBonus?: boolean
  userId?: UserId
  onSubmit(): void
}

const mapStateToProps = (state: IGlobalState, ownProps: IOwnProps): IStateProps => {
  const { goal, isMeView, isBonus, onSubmit } = ownProps
  return {
    goal,
    isMeView,
    isBonus,
    onSubmit,
    dailyDiary: getAllDailyProgressSelector(state),
    // @ts-ignore
    customProgress: getCustomProgressRawSelector(state, goal.id),
    manualEntryProgressType: getManualEntryProgressTypeSelector(state),
    manualEntryPointsLogicId: getManualEntryPointsLogicIdSelector(state),
    isManualEntryInProgress: getIsManualEntryInProgress(state),
    userCompanies: getUserCompanies(state),
  }
}

const mapDispatchToProps: IDispatchProps = {
  addCustomEntry,
  setManualEntryProgressType,
  setManualEntryPointsLogicId,
  getCustomProgressForPoints,
}

export default connect(mapStateToProps, mapDispatchToProps)(YumManualEntryForm)
